
import {  defineComponent } from 'vue';


export default defineComponent({
	name: 'AccountHeader',
	components: {

	},
	props: {
		title: {
			type: String,
			default: 'Schedule Service Appointment'
		}
	},
	setup() {

		return {

		};
	}
});
